import { Directive, Input, ElementRef, Renderer2, AfterViewInit, effect, inject } from '@angular/core';
import { StorageService } from '@services/core/storage.service';
import { UserService } from '@services/core/user.service';

@Directive({
  selector: '[appHasRole]',
  standalone: true
})
export class HasRoleDirective implements AfterViewInit {
  @Input() appHasRole:string[] = []; 
  private userService = inject(UserService)
  roleUser;

  constructor(private el: ElementRef, private renderer: Renderer2, private storageService: StorageService) {

      effect(()=> {
            this.roleUser = this.userService.sharingRole();
            this.ngAfterViewInit();
        })
  }

  ngAfterViewInit() {
    const userRole =this.roleUser?.name ?? 'visualizador';
    if (!this.appHasRole.includes(userRole)) {
      this.renderer.setStyle(this.el.nativeElement, 'visibility', 'hidden');
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'visibility', 'visible'); 
    }
  }
}
